class CachedCall {
	constructor(minimumTimeInMilliseconds) {
		this.lastRun = null;
		this.minimumTimeInMilliseconds = minimumTimeInMilliseconds;
	}

	static inMilliseconds(milliSeconds) {
		return new CachedCall(milliSeconds);
	}

	static inSeconds(seconds) {
		return CachedCall.inMilliseconds(seconds * 1000);
	}

	static inMinutes(minutes) {
		return CachedCall.inSeconds(minutes * 60);
	}

	reset() {
		this.lastRun = null;
	}

	run() {
		if(this.canRun()) {
			this.lastRun = Date.now();
			return true;
		}
		return false;
	}

	canRun() {
		if(this.lastRun === null || Date.now() - this.lastRun > this.minimumTimeInMilliseconds) {
			return true;
		}
		else {
			return false;
		}
	}

}

export { CachedCall };